import { Box, Button, Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";

export const TimePickerPopover = ({ onSelect, onClose }) => {
  const [selectedHour, setSelectedHour] = useState();
  const [selectedMinute, setSelectedMinute] = useState();

  const hours = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 / 5 }, (_, i) =>
    (i * 5).toString().padStart(2, "0")
  ).concat("59");

  const handleHourSelect = (hour) => {
    setSelectedHour(hour);
  };

  const handleMinuteSelect = (minute) => {
    setSelectedMinute(minute);
  };

  useEffect(() => {
    if (!!selectedHour && !!selectedMinute) {
      onSelect(`${selectedHour}:${selectedMinute}`);
      onClose();
    }
  }, [selectedHour, selectedMinute, onClose, onSelect]);

  return (
    <Box>
      <Flex gap={2}>
        <Box flex="1">
          <Text>Hora</Text>
          <Box height="185px" overflowY="auto" overflowX="hidden">
            <Grid templateColumns="repeat(1, 1fr)" gap={"2px"}>
              {hours.map((hour, index) => (
                <GridItem key={index}>
                  <Button
                    p={0}
                    key={hour}
                    _hover={{ bgColor: "#DDEBEA" }}
                    onClick={() => handleHourSelect(hour)}
                    color={selectedHour === hour ? "white" : undefined}
                    backgroundColor={
                      selectedHour === hour ? "#169499" : "#D7D8DE"
                    }>
                    {hour}
                  </Button>
                </GridItem>
              ))}
            </Grid>
          </Box>
        </Box>

        <Box flex="1">
          <Text>Minuto</Text>
          <Box height="185px" overflowY="auto" overflowX="hidden">
            <Grid templateColumns="repeat(1, 1fr)" gap={"2px"}>
              {minutes.map((minute, index) => (
                <GridItem key={index}>
                  <Button
                    p={0}
                    key={minute}
                    _hover={{ bgColor: "#DDEBEA" }}
                    onClick={() => handleMinuteSelect(minute)}
                    color={selectedMinute === minute ? "white" : undefined}
                    backgroundColor={
                      selectedMinute === minute ? "#169499" : "#D7D8DE"
                    }>
                    {minute}
                  </Button>
                </GridItem>
              ))}
            </Grid>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};
